<template>
    <div>
        <Header id="#top" />
        <router-view style="min-height: calc(100vh - 160px);"/>
        <Footer />
        <a class="top" href="#top">
            <a-icon type="vertical-align-top" style="font-size:22px; color:#707070" />
        </a>
    </div>
</template>

<script>
import Header from "@/components/newHomeHeader1.vue";
import Footer from "@/components/newHomeFooter1.vue";
export default {
    components:{Header,Footer}
}
</script>

<style>
.top{
        width:46px;
        height: 46px;
        line-height: 48px;
        text-align: center;
        box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.2);
        position: fixed;
        bottom:100px;
        right: 66px;
        i{
            font-size: 22px;
            color:#707070;
        }
    }
</style>